var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"middle-tip"},[_c('p',{staticClass:"tip"},[_vm._v(_vm._s(_vm.search_tip || '请输入摇号编码，或购房登记预审码进行查询。'))])])}
var staticRenderFns = []

export { render, staticRenderFns }